import * as React from 'react'
import Grid from '@mui/material/Grid';
import { Box, Button, CardContent, FormControl, FormControlLabel, Paper, Stack, Switch, TextField, Toolbar, Typography } from '@mui/material';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup"
import { defaultApi } from '../../api-interface';
import { useContext } from 'react';
import { TenantContext } from '../..';


export async function loader( register_id, register_secret) {
    try{
        const reg = await defaultApi.getPasswordResetResetPasswordIdSecretGet(register_id, register_secret)
        const ret = reg.data;
        return ret;
    } catch(e){
        if (e?.response?.data?.detail){
            throw new Error(e?.response?.data?.detail)
        }
        throw e
    }
}


const PasswordReset = () => {
    const { reset_id, reset_secret } = useParams();

    const currentTenant = useContext(TenantContext)
    const navigate = useNavigate()
    const email = useLoaderData() as string;

    const schema = yup
        .object({
            password: yup.string().required('Password is required').min(8, "Must Contain 8 Characters")
            .matches(
              /^(?=.*[a-z])/,
              " Must Contain One Lowercase Character"
            )
            .matches(
              /^(?=.*[A-Z])/,
              "  Must Contain One Uppercase Character"
            )
            .matches(
              /^(?=.*[0-9])/,
              "  Must Contain One Number Character"
            )
            .matches(
                /^(?=.*[!@#\$\-%\^&\*_])/,
                "  Must Contain One Special Character"
            ),
            password_confirmation: yup.string()
               .oneOf([yup.ref('password')], 'Passwords must match')
        })
        .required()

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })

    const handleResetPassword = async (form) => {
        try{
            await defaultApi.resetPasswordResetPasswordPost(
                {
                    password: form.password,
                    reset_id: reset_id!,
                    reset_secret: reset_secret!
                }
            )
        } catch(e){
            if (e?.response?.data?.detail){
                throw new Error(e?.response?.data?.detail)
            }
            throw e
        }
        navigate("/")
    }


    return (
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <Toolbar />
            <Grid container spacing={2} direction="row" alignItems="center" justifyContent="center">
                <Grid size={{xs:12, md:6, lg:4}} >
                    <Paper elevation={6}>
                        <CardContent>
                            <form onSubmit={handleSubmit(handleResetPassword)}>
                                <FormControl fullWidth>
                                    <Typography align="center" variant="h5">Password Reset</Typography>
                                    <TextField
                                        margin="normal"
                                        label="Email Address"
                                        type="text"
                                        variant='outlined'
                                        autoComplete="given-name"
                                        value={email}
                                        disabled
                                        required
                                    />
                                </FormControl>
                                <FormControl fullWidth>
                                    <TextField
                                        margin="normal"
                                        label="Password"
                                        placeholder="Password"
                                        {...register('password')}
                                        error={errors.password ? true : false}
                                        helperText={errors.password?.message?.toString()}
                                        type="password"
                                        variant='outlined'
                                        autoComplete='new-password'
                                        required
                                    />
                                    <TextField
                                        margin="normal"
                                        label="Password Confirmation"
                                        placeholder="Password Confirmation"
                                        {...register('password_confirmation')}
                                        error={errors.password_confirmation ? true : false}
                                        helperText={errors.password_confirmation?.message?.toString()}
                                        type="password"
                                        variant='outlined'
                                        autoComplete='new-password'
                                        required
                                    />
                                    <Button variant="contained" type="submit">Reset Password</Button>
                                </FormControl>
                            </form>
                        </CardContent>
                    </Paper>
                </Grid>
            </Grid>
        </Box>

    )
}

export default PasswordReset